import React from 'react';
import { Plug } from 'lucide-react';
import { saasHeroFloatIntegrations } from './saasHeroScreens';

export default function SaasHeroIntegrationRail({ compact = false, centered = false }) {
  const size = centered ? 'h-11 w-11' : compact ? 'h-7 w-7' : 'h-9 w-9 sm:h-10 sm:w-10';
  const imgSize = centered
    ? 'max-h-7 max-w-7'
    : compact
      ? 'max-h-4 max-w-4'
      : 'max-h-[22px] max-w-[22px] sm:max-h-6 sm:max-w-6';
  const plugSize = centered ? 'h-5 w-5' : compact ? 'h-3.5 w-3.5' : 'h-4 w-4';
  const pad = centered ? 'px-5 py-3' : compact ? 'px-2 py-1.5' : 'px-3 py-2.5';
  const gap = centered ? 'gap-3' : 'gap-1.5 sm:gap-2';

  return (
    <div
      className={`flex w-max flex-nowrap items-center rounded-full bg-white/95 backdrop-blur-sm border border-gray-100 shadow-[0_14px_32px_-6px_rgba(0,0,0,0.18)] ${pad} ${gap} ${
        centered ? 'mx-auto justify-center' : 'ml-auto justify-end'
      }`}
    >
      {saasHeroFloatIntegrations.map((integration) => (
        <div
          key={integration.name}
          className={`flex ${size} items-center justify-center rounded-full bg-gray-50 border border-gray-100 overflow-hidden shrink-0`}
          title={integration.name}
        >
          <img src={integration.image} alt={integration.alt} className={`${imgSize} object-contain`} />
        </div>
      ))}
      <div
        className={`flex ${size} items-center justify-center rounded-full bg-gray-50 border border-gray-100 shrink-0`}
        title="Custom API"
      >
        <Plug className={`${plugSize} text-gray-600`} strokeWidth={1.75} />
      </div>
    </div>
  );
}
